import { Toasts } from 'components'
import { FormHelpers } from 'utility/form-helpers'
import { validateInput, validateInputs } from 'utility/form-validation'
import { WarningIcon } from '../icons'

interface Location {
  id: string
  // Add other properties of the location object as needed
}

interface IDroppLocationsWindowExtension extends Window {
  chooseDroppLocation: () => Promise<Location | null>
}

declare let window: IDroppLocationsWindowExtension

const el = {
  root: document.querySelector<HTMLElement>('.checkout-layout--shipping'),
  forms: document.querySelectorAll<HTMLFormElement>(
    '#checkout-shipping-form, #checkout-shipping-form-mobile'
  ),
  radios: document.querySelectorAll<HTMLInputElement>(
    '.checkout-layout__options .radio-card__input'
  ),
  proceedButtons: document.querySelectorAll<HTMLButtonElement>(
    '#checkout-sidebar-proceed-button, #checkout-footer-proceed-button'
  ),
  inputs: document.querySelectorAll<HTMLInputElement>(
    '.checkout-layout--shipping input[required]'
  ),
  select: document.querySelector<HTMLInputElement>(
    '.checkout-layout--shipping select[required]'
  ),
  droppLocation: document.querySelector<HTMLDivElement>('.dropp-location__Name'),

  droppButtons: document.querySelectorAll<HTMLButtonElement>('.dropp-location__Button'),
}

export const CheckoutShipping = {
  init: () => {
    if (!el.root || !el.forms.length) return
    el.forms.forEach((target) =>
      target.addEventListener('submit', CheckoutShipping.onSubmit)
    )
    el.radios.forEach((target) =>
      target.addEventListener('change', CheckoutShipping.onRadioChange)
    )
    el.inputs.forEach((field) =>
      field.addEventListener('blur', CheckoutShipping.onTouched)
    )
    el.inputs.forEach((field) =>
      field.addEventListener('input', CheckoutShipping.onTextfieldChange)
    )
    if (el.select) el.select.addEventListener('change', CheckoutShipping.onSelectChange)
    CheckoutShipping.toggleProceedButtonState()

    CheckoutShipping.droppLocations()
  },

  droppLocations: () => {
    el.droppButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        window
          .chooseDroppLocation()
          .then((location) => {
            const origin = window.location.origin

            // Construct the URL using the origin and your specific endpoint path
            const url = `${origin}/umbraco/surface/orders/AddDroppLocationId`

            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: 'locid=' + location.id,
            })
              .then((response) => response.json()) // Assuming the server responds with JSON
              .then((data) => {
                if (data.success) {
                  const nameLocation = document.querySelector('.dropp-location__Name')
                  const titleLocation = document.querySelector('.dropp-location__Title')
                  if (nameLocation) {
                    titleLocation.classList.remove('radio-card__hidden')
                    nameLocation.classList.remove('radio-card__hidden')
                    nameLocation.innerHTML = data.location
                    CheckoutShipping.toggleProceedButtonState()
                  }
                }
              })
              .catch((error) => {
                console.error('Error:', error)
              })
          })
          .catch((error) => {
            // The modal may throw errors, for example if it cannot display locations.
          })
      })
    })
  },

  validateForm: ({ showErrors = false }) => {
    const someRadioChecked = Array.from(el.radios).some((x) => x.checked)
    const droppSelector = document.querySelector<HTMLInputElement>('.droppPickup')
    console.log(droppSelector)
    if (droppSelector != null && droppSelector.checked) {
      if (el.droppLocation.innerText.trim() === '') {
        return false
      }
    }

    if (!someRadioChecked) return false
    if (el.select && !el.select.value) return false
    if (!el.inputs.length) return true

    return validateInputs({ inputs: Array.from(el.inputs), showErrors })
  },

  toggleProceedButtonState: () => {
    const isFormValid = CheckoutShipping.validateForm({ showErrors: false })
    if (!isFormValid) {
      el.proceedButtons.forEach((target) => (target.disabled = true))
      return
    }
    el.proceedButtons.forEach((target) => (target.disabled = false))
  },

  onSelectChange: (e: Event & { target: HTMLSelectElement }) => {
    CheckoutShipping.toggleProceedButtonState()
  },

  onRadioChange: () => {
    FormHelpers.submitForm({
      form: el.forms[0],
      buttons: Array.from(el.proceedButtons),
      onSuccess: () => window.location.reload(),
      onError: () => () =>
        Toasts.addToast({
          title: 'Villa kom upp!',
          text: 'Ekki tókst að vista afhendingarmáta',
          icon: WarningIcon(),
        }),
    })
  },

  onTouched: (e: Event & { target: HTMLInputElement }) => {
    if (!e.target.classList.contains('touched')) {
      e.target.classList.add('touched')
    }
  },

  onTextfieldChange: (e: Event & { target: HTMLInputElement }) => {
    if (e.target.classList.contains('autovalidate')) {
      validateInput({ input: e.target, showError: true })
    }
    CheckoutShipping.toggleProceedButtonState()
  },

  onSubmit: (e: Event & { target: HTMLFormElement }) => {
    e.preventDefault()

    const isValidForm = CheckoutShipping.validateForm({ showErrors: true })
    if (!isValidForm) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text: 'Þú þarft að velja afhendingarmáta.',
        icon: WarningIcon(),
      })
      return
    }

    if (!el.inputs.length && !el.select) {
      window.location.href = CheckoutShipping.getRedirectUrl()
      return
    }

    // submit form if there are required fields
    FormHelpers.submitForm({
      form: el.forms[0],
      buttons: Array.from(el.proceedButtons),
      onSuccess: () => (window.location.href = CheckoutShipping.getRedirectUrl()),
      onError: () =>
        Toasts.addToast({
          title: 'Villa kom upp!',
          text: 'Ekki tókst að afhendingarmáta.',
          icon: WarningIcon(),
        }),
    })
  },

  getRedirectUrl: () =>
    document.querySelector<HTMLButtonElement>('#checkout-sidebar-proceed-button')?.dataset
      .href || '',
}
